import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import Paper from '@material-ui/core/Paper';
import TableRow from '@material-ui/core/TableRow';
import Divider from '@material-ui/core/Divider';
import { useSimulateStyles, BodyTableRow } from "../simulate-report/simulation.style";
import SingleSelect from "../common/dropdown/SingleSelect.component";

const metricItems = [{ data: "grps", label: "GRPs" }, { data: "impressions", label: "Impressions" }, { data: "spend", label: "Spend" }]

function OptimizationReportTable(props) {
    const classes = useSimulateStyles();
    const { data, filter, headers, metrics, handleMetricSelection } = props;
    const [filteredData, setFilteredData] = React.useState([])
    // const [metrics, setMetrics] = React.useState({})
    const getTotal = (data, key) => {
        return data.reduce((total, el) => el ? total + el[key] : total, 0)
    }
    // const handleMetricSelection = (data, index) => {
    //     let met = { ...metrics }
    //     met["metric_" + index] = data;
    //     setMetrics(met);
    // }
    React.useEffect(() => {
        let filteredData = data.contentTypes.map(el => {
            let temp = []
            let dataArr = el.mediums.filter(item => {
                let index = temp.indexOf(item.medium)
                if (index === -1) {
                    temp.push(item.medium)
                    return true
                }
                return false
            }).reduce((o, data) => ({ ...o, ["medium_" + headers.indexOf(data.medium)]: data }), {});
            // var maparr = new Map(dataArr)
            el.result = dataArr;
            return el
        })
        setFilteredData(filteredData)
    }, [data])
    return (
        <div style={{ marginTop: 20 }}>
            {/* {props.index !== 0 && <div className={classes.nameCont} style={{ width: "calc(100% - 30px)", display: "flex", height: 32, marginTop: 20, alignItems: "flex-end", padding: "5px" }}>
                <div className={classes.name} style={{ padding: 5 }}>{data ?.network}</div>
            </div>} */}
            <TableContainer className={classes.tableCont1} component={Paper} style={{ padding: "0px" }}>
                <Table stickyHeader className={classes.table}>
                    <TableHead>
                        <TableRow>
                            <th className={classes.tableCell} style={{ position: "sticky", top: 0, left: 0, zIndex: 999, width: 180, minWidth: 180, maxWidth: 180, textAlign: "left", color: "#fff", backgroundColor: "#00adee" }}>
                                <div className={classes.name} style={{ fontSize: "1rem", padding: "6.5px 5px", paddingLeft: 10 }}>{data ?.network}</div>
                            </th>
                            {headers && headers.map((header, index) => (
                                <th key={index} className={classes.tableCell} colSpan="2" style={{ width: 180, minWidth: 180, maxWidth: 180, padding: 5, position: "sticky", top: 0, left: 0, zIndex: 5, color: "#fff", backgroundColor: "#00adee" }}>

                                    {header}
                                </th>
                            ))}
                            <th style={{ position: "sticky", top: 0, left: 0, zIndex: 99999, padding: 0, color: "#fff", backgroundColor: "#00adee" }}>
                                {/* {props.index === 0 && <div style={{ height: 45 }}></div>} */}
                                <div style={{ padding: 5 }}>Total</div>
                            </th>
                        </TableRow>
                        <TableRow>
                            <th className={classes.tableCell} style={{ position: "sticky", top: 37, left: 0, zIndex: 999, textAlign: "left", backgroundColor: "#dde6ed" }}>
                                {/* {props.index === 0 && <><div className={classes.name} style={{ fontSize: "1rem", padding: "11.5px 5px", paddingLeft: 10 }}>{data ?.network}</div></>} */}
                                <div style={{ padding: 5 }}>Content Type</div></th>
                            {/* <div style={{ padding: 5, border: "1px solid #ccc" }}>Content Type</div></th> */}
                            {headers && headers.map((header, index) => (
                                <>

                                    <th key={index} className={classes.tableCell} style={{ width: 130, minWidth: 130, maxWidth: 130, position: "sticky", top: 37, left: 0, zIndex: 5, backgroundColor: "#dde6ed" }}>
                                        <div style={{ padding: 5 }}>
                                            {props.index === 0 ?
                                                <SingleSelect
                                                    items={metricItems}
                                                    defaultValue={metrics["metric_" + index]}
                                                    onChange={data => handleMetricSelection(data, index)}
                                                    labelKey={"label"}
                                                />
                                                :
                                                metrics["metric_" + index] ?.label ? metrics["metric_" + index] ?.label : "GRPs"
                                            }
                                        </div>
                                    </th>
                                    <th style={{ width: 100, minWidth: 100, maxWidth: 100, position: "sticky", top: 37, left: 0, zIndex: 5, backgroundColor: "#dde6ed" }}>
                                        {filter === "uplift" ? "Uplift" : "Viewing Minutes"}
                                    </th>
                                </>
                            ))}
                            <th style={{ position: "sticky", minWidth: 100, top: 37, left: 0, zIndex: 99999, padding: 5, backgroundColor: "#dde6ed" }}>
                                {filter === "uplift" ? "Uplift" : "Viewing Minutes"}
                            </th>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            filteredData.map((el, index) => (
                                <BodyTableRow key={index}>
                                    <td style={{ whiteSpace: "nowrap", position: "sticky", padding: 5, top: 0, left: 0, zIndex: 99, backgroundColor: "inherit", fontSize: "0.85rem", textAlign: "left" }}>{el.contentType}</td>
                                    {
                                        el.result && headers.map((medium, index1) => (
                                            <React.Fragment key={index + "_" + index1}>
                                                <td style={{ padding: 0, minWidth: 80, fontSize: "0.85rem", backgroundColor: el.result["medium_" + index1] ? "" : "#ddd" }}>
                                                    {el.result["medium_" + index1] ? el.result["medium_" + index1][metrics["metric_" + index1] ? metrics["metric_" + index1].data : "grps"].toLocaleString('en-US') : ""}
                                                </td>
                                                <td style={{ padding: 0, minWidth: 80, fontSize: "0.85rem", backgroundColor: el.result["medium_" + index1] ? "" : "#ddd" }}>
                                                    {el.result["medium_" + index1] && filter === "uplift" && "+"}
                                                    {el.result["medium_" + index1] ? filter === "uplift" ? el.result["medium_" + index1][filter] : el.result["medium_" + index1][filter].toLocaleString('en-US') : ""}
                                                    {el.result["medium_" + index1] && filter === "uplift" && "%"}
                                                </td>
                                            </React.Fragment>

                                            // <BodyTableCell classes={{ root: classes.tableCell }} key={index + "_" + index1}>
                                            //     <div style={{ display: "flex" }}>
                                            //         <div style={{ padding: 5, width: "calc(50% - 10px)", borderRight: "1px solid #dde6ed" }}>
                                            //             {el.result["medium_" + index1] ? el.result["medium_" + index1]["grps"] : ""}
                                            //         </div>
                                            //         <div style={{ padding: 5, width: "calc(50% - 10px)" }}>
                                            //             {el.result["medium_" + index1] ? el.result["medium_" + index1][filter] : ""}
                                            //         </div>
                                            //     </div>
                                            // </BodyTableCell>
                                        ))
                                    }
                                    {/* <td style={{ padding: 0, minWidth: 80 }}>{getTotal(el.mediums, "grps")}</td> */}
                                    <td style={{ padding: 0, minWidth: 80, fontSize: "0.85rem" }}>{filter === "uplift" ? <>{`+${+parseFloat(getTotal(el.mediums, filter)).toFixed(2)}%`}</> : getTotal(el.mediums, filter).toLocaleString('en-us')}</td>
                                </BodyTableRow>
                            ))
                        }
                        <BodyTableRow>
                            <th align="left" style={{ backgroundColor: "inherit", position: "sticky", left: 0 }}>Total</th>
                            {headers.map((medium, index) => {
                                const data = filteredData.map(el => el.result["medium_" + index]);
                                return (<React.Fragment key={"total_" + index}>
                                    <td>
                                        {getTotal(data, metrics["metric_" + index].data).toLocaleString('en-us')}
                                    </td>
                                    <td>
                                        {filter === "uplift" ? <>{`+${+parseFloat(getTotal(data, filter)).toFixed(2)}%`}</> : getTotal(data, filter).toLocaleString('en-us')}
                                    </td>
                                </React.Fragment>)
                            }
                            )
                            }
                            <td></td>
                        </BodyTableRow>
                    </TableBody>
                </Table>

            </TableContainer>
        </div>
    )
}

export default OptimizationReportTable;